export default require("../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/lodash.js");